<template>
    <v-flex xs12 fill-height>
        <v-container fluid grid-list-sm>
            <v-layout row wrap>
                <v-flex xs12>
                    <apollo-query client-id="clientPrivate"
                                  :query="require('../graphql/queries/stations.gql')">


                        <template v-slot="{ result: { error, data }, isLoading }">

                            <template v-if="data">
                                <v-list class="no-background">
                                    <v-list-tile v-for="station in data.stations.nodes"
                                                 :key="station.id"
                                                 :to="{name: 'station-pickup',params: { sgid: station.sgid }}"
                                                 class="station">

                                        <v-list-tile-content>


                                            <v-list-tile-title class="station-title">
                                                {{station.name|uppercase}} ({{$vuetify.t(`$vuetify.generic.station_statues.${$options.filters.lowercase(station.state)}`)}})
                                            </v-list-tile-title>
                                            <v-list-tile-sub-title
                                                    class="station-info mt-1">
                                                <v-layout wrap row class="box-info">
                                                    <v-flex xs6 class="info-label">
                                                        {{$vuetify.t("$vuetify.Stations.address")|uppercase}}
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        {{station.address}}
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout wrap row class="box-info">
                                                    <v-flex xs6 class="info-label">
                                                        {{$vuetify.t("$vuetify.Stations.totalSeats")|uppercase}}
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        {{station.bays.totalCount}}
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout wrap row class="box-info">
                                                    <v-flex xs6 class="info-label">
                                                        {{$vuetify.t("$vuetify.Stations.availableSeats")|uppercase}}
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        {{station.freeBay}}
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout wrap row class="box-info">
                                                    <v-flex xs6 class="info-label">
                                                        {{$vuetify.t("$vuetify.Stations.availableVehicles")|uppercase}}
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        {{station.availableVehicles}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action>
                                            <v-icon color="bluetext">mdi-chevron-right
                                            </v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </template>

                            <v-layout v-if="isLoading" class="loading" row wrap align-center
                                      justify-center fill-height>
                                <v-flex shrink>
                                    <v-progress-circular
                                            :size="70"
                                            :width="1"
                                            height="15"
                                            indeterminate
                                            color="blueprimary"
                                    ></v-progress-circular>
                                </v-flex>
                            </v-layout>


                        </template>




                    </apollo-query>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>

    import iconStationOn from '../assets/markerpng.png'
    import iconStationOff from '../assets/markeroffline.png'

    export default {
        name: 'Stations',
        data() {
            return {
                iconStationOn
            }
        },
        methods: {
            $_getStatusCssClass(state){
                if (state=== "READY") {
                    return "success"
                } else {
                    return "error"
                }
            }
        }

    }
</script>

<style scoped lang="scss">

    .no-background {
        background-color: transparent;
    }

    .loading{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .station {
        margin: 8px 0px;
        background-color: #fff;
        padding: 8px 0px;

        & /deep/ .v-list__tile {
            height: auto;
        }

        & /deep/ .v-list__tile__action {
            min-width: 25px;
        }

        .status-bar {
            white-space: normal;
            height: auto;
            overflow-y: visible;
            width: 100%;

            .status_badge {
                color: var(--v-primary-base);
                
                .success {
                    background-color: var(--v-success-base);
                }

                .error {
                    background-color: var(--v-error-base);
                }

            }

        }

        .station-title {
            color: var(--v-bluetext-base);
            font-weight: bold;
            height: auto;
            white-space: normal;
            overflow-y: visible;


        }

        .station-info {
            white-space: normal;
            font-size: 12px;

            .box-info {
                .info-label {
                    font-weight: bold;
                }

            }
        }
    }

</style>